import { useContext, useEffect, useState } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { UserContext } from 'Context/user';

export const useClientSideDPSellerIdExperiment = (flag: string, triggerExperiment = false) => {
  const [decision, setDecision] = useState(false);
  const { optimizely } = useContext(OptimizelyContext);
  const { userState: user } = useContext(UserContext);
  const userDPSellerId = user?.dpSellerId;

  useEffect(() => {
    if (!triggerExperiment || !userDPSellerId) {
      return;
    }

    optimizely?.onReady().then(() => {
      const result = optimizely.decide(flag, undefined, String(userDPSellerId));
      setDecision(result.enabled && result.variationKey === 'on');
    });
  }, [optimizely, flag, triggerExperiment, userDPSellerId]);

  return decision;
};
